import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAngellistComponent } from './simple-icons-angellist.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAngellistComponent ],
    exports:      [ SimpleIconsAngellistComponent ],
    bootstrap:    []
})
export class SimpleIconsAngellistModule {}
